/* eslint-disable react/prop-types */
import React from 'react';
import { Button, Form, FormGroup, Input, Label, Spinner } from 'reactstrap';

import { Container } from './styles';

function CadastroCard({ handleSubmit, setForm, form, loading }) {
  return (
    <Container>
      <h1>Cadastrar página</h1>
      <Form onSubmit={handleSubmit} style={{ width: '100%' }}>
        <FormGroup>
          <Label>Nome da página</Label>
          <Input
            name="nome"
            id="nome"
            type="text"
            placeholder="Insira o nome da página"
            onChange={(e) => {
              setForm({ ...form, name: e.target.value });
            }}
          />
        </FormGroup>
        <FormGroup tag="fieldset">
          <Label>Situação cadastral</Label>
          <FormGroup check>
            <Label check>
              <Input
                type="radio"
                name="radio1"
                onChange={() => setForm({ ...form, idSituacaoCadastral: 1 })}
              />
              Ativo
            </Label>
          </FormGroup>
          <FormGroup check>
            <Label check>
              <Input
                type="radio"
                name="radio1"
                onChange={() => setForm({ ...form, idSituacaoCadastral: 2 })}
              />
              Inativo
            </Label>
          </FormGroup>
        </FormGroup>
        {loading ? (
          <Button color="primary" disabled>
            <Spinner color="light" size="sm" />
          </Button>
        ) : (
          <Button color="primary" onClick={handleSubmit}>
            Cadastrar
          </Button>
        )}
      </Form>
    </Container>
  );
}

export default CadastroCard;
